export const isProduction = process.env.REACT_APP_CUSTOM_NODE_ENV === "production";
export const isPreProduction = process.env.REACT_APP_CUSTOM_NODE_ENV === "preproduction";
export const isDevelopment = process.env.REACT_APP_CUSTOM_NODE_ENV === "development";
export const isPilot = process.env.REACT_APP_CUSTOM_NODE_ENV === "pilot";
export const oktaIssuer = process.env.REACT_APP_OKTA_ISSUER;
export const oktaClientId = process.env.REACT_APP_OKTA_CLIENT_ID;
export const baseURL = process.env.REACT_APP_BASE_URL;
export const apiURL = process.env.REACT_APP_API_URL;
export const pushServerPublicKey = process.env.REACT_APP_PUSH_SERVER_PUBLIC_KEY;
export const googleTrackingId = process.env.REACT_APP_GOOGLE_TRACKING_ID;
export const appDefaultLanguage = process.env.REACT_APP_DEFAULT_LANGUAGE;
export const requirePluginId = process.env.REACT_APP_REQUIRE_PLUGIN_ID;
export const hotjarId = process.env.REACT_APP_HOTJAR_ID;
export const gtmId = process.env.REACT_APP_GTM_ID;
export const appLogo = "/images/logos/logo--white.svg";
export const defaultUserPicture = "";
export const appVersion = process.env.REACT_APP_VERSION || "1.1.0";
export const i18n = {
    languages: [
        {
            key: "tr",
            flag: "tr-TR",
            title: "Türkçe",
        },
        {
            key: "en",
            flag: "en-US",
            title: "English",
        },
    ],
    defaultLanguage: "tr",
};
